function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "22 22 56 56",
  preserveAspectRatio: "xMidYMid"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.875s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor",
  transform: "rotate(45 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.75s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor",
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.625s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor",
  transform: "rotate(135 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor",
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.375s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor",
  transform: "rotate(225 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.25s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor",
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.125s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("rect", {
  x: "44",
  y: "22",
  rx: "6",
  ry: "6",
  width: "12",
  height: "12",
  fill: "currentColor",
  transform: "rotate(315 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
})));